import SignupForm from './signupForm'

export default SignupForm
